import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { StoreProvider } from './contexts/StoreContext';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { CompareBar } from './components/CompareBar';
import { VirtualAssistant } from './components/assistant/VirtualAssistant';
import { QuickScoringPanel } from './components/credit/QuickScoringPanel';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { VehicleDetail } from './pages/VehicleDetail';
import { Simulator } from './pages/Simulator';
import { CreditCheck } from './pages/CreditCheck';
import { Compare } from './pages/Compare';
import { Brands } from './pages/Brands';
import { BrandDetail } from './pages/BrandDetail';
import { Admin } from './pages/Admin';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
interface AppProps {
  /** Muestra las unidades de ejemplo junto a las de la planilla hasta que se cargue el inventario real. */
  showExampleVehicles?: boolean;
}
export function App({
  showExampleVehicles = true
}: AppProps) {
  return <StoreProvider showExamples={showExampleVehicles} data-id="element-0" data-mp="6hqtghuuhen">
      <BrowserRouter data-id="element-1" data-mp="56lhc8rh1lf">
        <ScrollToTop data-id="element-2" data-mp="2zl3a7gleoy37" />
        <div className="flex min-h-screen w-full flex-col bg-ink text-white" data-id="element-3" data-mp="2zllduyaeeel5">
          <Header data-id="element-4" data-mp="33movnqc0akp0" />
          <main className="flex-1 pb-20" data-id="element-5" data-mp="33m5c656pjo8v">
            <Routes data-id="element-6" data-mp="33mym1f0yqtv8">
              <Route path="/" element={<Home data-id="element-8" data-mp="38m1jadapbvsn" />} data-id="element-7" data-mp="33oi2p6qj76xj" />
              <Route path="/catalogo" element={<Catalog data-id="element-10" data-mp="38kgocmkh6au9" />} data-id="element-9" data-mp="38kqbm2e4y3w9" />
              <Route path="/vehiculo/:id" element={<VehicleDetail data-id="element-12" data-mp="3dlw542fmdv6u" />} data-id="element-11" data-mp="3dkus3sf1mymh" />
              <Route path="/simulador" element={<Simulator data-id="element-14" data-mp="nvstx4mognvy" />} data-id="element-13" data-mp="3diruonbka37q" />
              <Route path="/chequeo" element={<CreditCheck data-id="element-16" data-mp="nvan5e2e2r9s" />} data-id="element-15" data-mp="nuhiqjqwkdut" />
              <Route path="/comparar" element={<Compare data-id="element-18" data-mp="stkoy7imcq4d" />} data-id="element-17" data-mp="sudkecc4nt77" />
              <Route path="/marcas" element={<Brands data-id="element-20" data-mp="36hvn4muyo06" />} data-id="element-19" data-mp="ssss6tdacmci" />
              <Route path="/marcas/:slug" element={<BrandDetail data-id="element-22" data-mp="34nbhsjeuzx5" />} data-id="element-21" data-mp="35oxut5vn8u6" />
              <Route path="/admin" element={<Admin data-id="element-24" data-mp="3udkmtw2p4uae" />} data-id="element-23" data-mp="3uct3bjmdin0h" />
              <Route path="*" element={<Home data-id="element-26" data-mp="3uf5ixq4nslad" />} data-id="element-25" data-mp="3uc9jfxd5xojt" />
            </Routes>
          </main>
          <Footer data-id="element-27" data-mp="d3cvbquvaug1" />
          <CompareBar data-id="element-28" data-mp="d3wbp34vdary" />
          <VirtualAssistant data-id="element-29" data-mp="d2bfl92wpjrz" />
          <QuickScoringPanel data-id="element-30" data-mp="85bbv4tj4t41" />
        </div>
        <Toaster theme="dark" position="top-center" richColors data-id="element-31" data-mp="86clr5yt79k6" />
      </BrowserRouter>
    </StoreProvider>;
}